import React from 'react';

import LeftBar from '../Dashboard/LeftBar'

const TemporaryDrawer = ({ drawerOpen, handleDrawerToggle, handleChange, value, isSmallScreen }) => {
  
    return (
        <LeftBar
        drawerOpen={drawerOpen}
        handleDrawerToggle={handleDrawerToggle}
        handleChange={handleChange}
        value={value}
        isSmallScreen={isSmallScreen}
      />
    );
};

export default TemporaryDrawer;
